import { tv } from 'tailwind-variants';

const dealIndicatorStyles = tv({
    slots: {
        container: `
      iris:font-(family-name:--comp-type-font-label-tag)
      iris:font-(--comp-type-weight-label-tag)!    
    `,
    },
    variants: {
        variant: {
            great: {
                container: `
          iris:bg-(--comp-color-background-deal-indicator-great-price-tag)
          iris:text-(--comp-color-content-deal-indicator-great-price-tag)
        `,
            },
            good: {
                container: `
          iris:bg-(--comp-color-background-deal-indicator-good-price-tag)
          iris:text-(--comp-color-content-deal-indicator-good-price-tag)
        `,
            },
        },
        // New inverse toggle
        inverse: {
            false: {},
            true: {},
        },
    },
    // Switch to inverse tokens when inverse=true
    compoundVariants: [
        {
            variant: "great",
            inverse: true,
            class: {
                container: `
          iris:bg-(--comp-color-background-deal-indicator-great-price-tag-inverse)
          iris:text-(--comp-color-content-deal-indicator-great-price-tag-inverse)
        `,
            },
        },
        {
            variant: "good",
            inverse: true,
            class: {
                container: `
          iris:bg-(--comp-color-background-deal-indicator-good-price-tag-inverse)
          iris:text-(--comp-color-content-deal-indicator-good-price-tag-inverse)
        `,
            },
        },
    ],
    defaultVariants: {
        variant: "great",
        inverse: false,
    },
});

export { dealIndicatorStyles as default };
